
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/urban-planning-optimization-homelessness",
      function () {
        return require("private-next-pages/articles/urban-planning-optimization-homelessness.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/urban-planning-optimization-homelessness"])
      });
    }
  